import Vue from 'vue'
import Vuex from 'vuex'
import { post } from "@/utils/http"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        passport: null,
        collapsed: null,
        authMenus:null,
        authButtons:null,
    },
    getters: {
        passport: state => {
            if (!state.passport || JSON.stringify(state.passport) == "{}") {
                state.passport = JSON.parse(localStorage.getItem("passport"));
            }
            return state.passport;
        },
        getCollapsed: state => {
            if (state.collapsed === null) {
                state.collapsed = localStorage.getItem("collapsed") || false;
            }
            return state.collapsed;
        },
        getAuthMenus: state => {
            if (!state.authMenus) {
                state.authMenus = JSON.parse(localStorage.getItem("authMenus"));
            }
            return state.authMenus;
        },
        getAuthButtons: state => {
            if (!state.authButtons) {
                state.authButtons = JSON.parse(localStorage.getItem("authButtons"));
            }
            return state.authButtons;
        },
    },
    mutations: {
        PASSPORT: (state, data) => {
            state.passport = data;
            localStorage.setItem("token", data.id);
            localStorage.setItem("passport", JSON.stringify(data));
        },
        setCollapsed: (state) => {
            state.collapsed = !state.collapsed;
            localStorage.setItem("collapsed", data);
        },
        setAuthMenus: (state, data) => {
            state.authMenus = data;
            localStorage.setItem("authMenus", JSON.stringify(data));
        },
        setAuthButtons: (state, data) => {
            state.authButtons = data;
            localStorage.setItem("authButtons", JSON.stringify(data));
        },
    },
    actions: {
        handleAuth: ({commit}, passport) => {
            return new Promise((resolve, reject) => {
                post("/auth/getRoleAcls", {}).then((res) => {
                    if (res) {
                        commit('setAuthMenus', res.activeMenus);
                        commit('setAuthButtons', res.activeButtons);
                    }
                    resolve(res.activeMenus);
                });
            })
        },
        setPassport: ({ commit }, passport) => {
            commit("PASSPORT", passport);
        },
    }
})